(function(){
  var root = document.getElementById('amx'); if(!root) return;

  if('IntersectionObserver' in window){
    var io = new IntersectionObserver(function(es){
      es.forEach(function(e){ if(e.isIntersecting){ e.target.classList.add('in'); io.unobserve(e.target); } });
    },{threshold:.12});
    root.querySelectorAll('.rv').forEach(function(el){ io.observe(el); });
  } else {
    root.querySelectorAll('.rv').forEach(function(el){ el.classList.add('in'); });
  }

  window.amxFaq = function(btn){
    var item = btn.parentElement, body = btn.nextElementSibling, open = item.classList.contains('open');
    root.querySelectorAll('.fi').forEach(function(f){
      f.classList.remove('open');
      var b = f.querySelector('.fb'); if(b) b.style.maxHeight = null;
    });
    if(!open){ item.classList.add('open'); body.style.maxHeight = body.scrollHeight + 'px'; }
  };

  window.addEventListener('resize', function(){
    var o = root.querySelector('.fi.open .fb');
    if(o) o.style.maxHeight = o.scrollHeight + 'px';
  });
})();
